<template>
  <div>
    <PageHeader title="Past Winners"></PageHeader>
    <v-container>
      <v-row>
        <v-col class="text-right">
          <router-link :to="{name: 'active-competitions'}">Competitions</router-link>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pa-0">
      <v-row>
        <v-col>
          <h3 v-if="pastWinners && pastWinners.length === 0">No recent winners</h3>
          <v-card
            outlined
            v-for="winner in pastWinners" :key="winner.competitionId"
            class="mb-4"
          >
            <v-container>
              <v-row>
                <v-col>
                  <div :id="trimGuid(winner.competitionId)">
                    <span class="honey-colour">{{winner.ownTeamName}}</span> {{winner.name.replace(winner.ownTeamName,'')}}
                  </div>
                  <v-icon color="#757575">mdi-calendar-blank-outline</v-icon> <span class="competition-date-time">{{winner.matchStartDate | moment("DD MMM YY")}}</span>
                  <v-icon color="#757575">mdi-clock-outline</v-icon> <span class="competition-date-time">{{winner.matchStartDate | moment("HH:mm")}}</span>
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="5" align="center">
                  <div class="mt-3">
                    <v-icon color="fanhiveHoney" large>mdi-account-circle</v-icon>
                    <div class="competition-team-name">
                      {{winner.fanUserName}}
                    </div>
                    <div class="honey-colour winnings-text">
                      £{{winner.fanWinnings}}
                    </div>
                  </div>
                </v-col>
                <v-col cols="2" align="center">
                  <img :src="require('@/assets/vs-winners.png')" class="VS" />
                </v-col>
                <v-col cols="5" align="center">
                  <div v-for="player in winner.players" :key="player.playerName" class="mt-3">
                    <img :src="player.photoUrl" style="height: 35px;">
                    <div class="competition-team-name">
                      {{player.playerName}}
                    </div>
                    <div class="honey-colour winnings-text">
                      <div v-if="winner.playerWinnings > 0">
                        £{{winner.playerWinnings}}
                      </div>
                      <div v-if="winner.playerWinnings === 0">
                        <v-icon color="fanhiveHoney">mdi-trophy</v-icon>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="winner.sponsorId">
                <v-col>
                  <a :href="winner.website" target="_blank">
                    <img :src="winner.sponsorLogo" :alt="winner.sponsorName" class="sponsor-logo">
                  </a>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import _ from 'lodash';

export default {
  name: 'pastwinners',
  components: {
    PageHeader
  },
  data: () => ({
    pastWinners: null,
    overlay: false
  }),
  methods: {
    testPurchase: function () {
      this.$router.push({name: 'active-competitions', query: { 
        paymentApproved: true,
        amount: 2
      }});
    },
    trimGuid: function (str) {
      return 'ex' + str.split('-').join('');
    },
    getPastWinners: function (slugParams) {
      this.overlay = true;
      var scope = this;
      this.$store.dispatch('getCustom', slugParams).then(response => {
        scope.pastWinners = [];
        _.forEach(response, (pw) => {
          var allDeets = pw.playerNames.split('|');
          var players = [];
          allDeets.forEach(allDeet => {
            var playerDeets = allDeet.split(',');
            players.push({ playerName: playerDeets[0], photoUrl: playerDeets[1]})
          });
          pw.players = players;
          scope.pastWinners.push(pw);
        });
        scope.pastWinners = response;
        scope.overlay = false

        if(scope.$route.query.competitionId !== undefined) {
          setTimeout(() => {
            scope.$scrollTo('#' + scope.trimGuid(scope.$route.query.competitionId));
          }, 1000);
        }

      }, error => {
          console.log(error);
      });
    }
  },
  created () {
    var slugParams = {
      slug: 'pastwinners',
      params: ''
    };
    this.getPastWinners(slugParams);
  }
}
</script>